<template>
	<div class='fill-height pt-2'  :class="{ 'd-flex align-center justify-center': loading }">
		<div v-if='loading' class='fill-height d-flex flex-column justify-center align-center' style='height: 600px;'>
			<div 
				:class='{
					"loader-eye-dark": $vuetify.theme.dark,
					"loader-eye": !$vuetify.theme.dark,
				}'></div>

			<div
				:class='{
					"loader-dark": $vuetify.theme.dark,
					"loader": !$vuetify.theme.dark,
				}'
			></div>
		</div>
		<div v-else>
			<v-row class='mt-0' >
				<v-col cols='2'>
					<bee-date-input
						v-model='selectedMonth'
						:label="selectedMonth ? `${moment(selectedMonth).format('MMMM')}` : 'Date'"
						:loading='loading'
						:disabled='loading'
						dense
						hide-details
						input-format-order='year-month-day'
						input-type='month'
						append-icon='mdi-menu-right'
						prepend-icon='mdi-menu-left'
						readonly
						fit-inputs
						@click:append='nextMonth()'
						@click:prepend='prevMonth()'
					></bee-date-input>
				</v-col>
			</v-row>
			<apexchart 
				class='apexchart'
				type='heatmap' 
				height='910' 
				width='100%' 
				:options='chartOptions' 
				:series='series'
			></apexchart>

			<v-menu
				v-model="showMenu"
				:position-x="menuX"
				:position-y="menuY"
				absolute
				offset-y
			>
				<v-list>
					<v-list-item @click="onEdit">
						<v-list-item-title>تعديل</v-list-item-title>
					</v-list-item>
					<v-list-item @click="onDetails">
						<v-list-item-title>تفاصيل</v-list-item-title>
					</v-list-item>
				</v-list>
			</v-menu>
		</div>
	</div>
</template>
<script>
import moment from 'moment';
import { mapGetters, mapState } from 'vuex';
export default {
	data () {
		return {
			tab: null,
			loading: false,
			usersRang: [],
			isAfterToday: false,
			isFriday: false,
			selectedMonth: this.moment().format('YYYY-MM'),
			showMenu: false,
			menuX: 0,
			menuY: 0,
			selectedWorkday: null,
			lastHoveredDataPoint: null
		}
	},

	computed: {
		...mapState({
			usersWithoutPag: state => state.users.usersWithoutPag
		}),
		...mapGetters({
			getUserWithoutPagById: 'users/getUserWithoutPagById'
		}),
		
		series () {
			// return	this.usersRang.map(c => ({
			// 	name: this.getUserWithoutPagById(c.userId)?.arabicFirstName + ' ' + this.getUserWithoutPagById(c.userId)?.arabicLastName,
			// 	data: c.data
			// }))
			return	this.usersRang.map(c => ({
				name: this.usersWithoutPag.find(s => s.id === c.userId)?.employee.arabicFirstName + ' ' + this.usersWithoutPag.find(s => s.id === c.userId)?.employee.arabicLastName,
				data: c.data
			}))
		},        
		chartOptions () {
			return {
				chart: {
					height: 350,
					type: 'heatmap',
					events: {
						dataPointMouseEnter: (event, chartContext, config) => {
							this.lastHoveredDataPoint = config;
						},
						dataPointMouseLeave: () => {
							// We can clear it on leave, but it's better to keep it for the click
							// this.lastHoveredDataPoint = null;
						},
						click: (event, chartContext) => {
							if (!this.lastHoveredDataPoint || this.lastHoveredDataPoint.seriesIndex < 0) {
								return;
							}

							const { seriesIndex, dataPointIndex } = this.lastHoveredDataPoint;
							const workday = chartContext.w.config.series[seriesIndex].data[dataPointIndex];

							if (workday.x === 'R H' || workday.x === 'A W H') {
								return;
							}
							this.selectedWorkday = workday;
							this.showMenu = false;
							this.menuX = event.clientX;
							this.menuY = event.clientY;
							this.$nextTick(() => {
								this.showMenu = true;
							});
						}
					}
				},
			
				plotOptions: {
					heatmap: {
						style: {
							width: 30,
							height: 30 
						},
						colorScale: {
							ranges: [
								{
									from: 6.9,
									to: 12,
									color: '#00A100'
								},
								{
									from: 6,
									to: 6.9,
									color: '#ffb1b1'
								},
								{
									from: 0,
									to: 6,
									color: '#eb0606'
								},
								{
									from: -1000,
									to: -0.001,
									color: '#ff0000',
									name: ' '
								},
								{
									from: null,
									to: null,
									color: '#b7b7b7',
									name: ' '
								},
								{
									from: 1000,
									to: 1100,
									color: '#ff9800',
									name: 'إجازة'
								}
							]
						}
					}
				},
				dataLabels: {
					formatter: function (val, opts) {
						if (val === null || val === undefined) {
							return ''
						}
						let displayVal = val
						if (val >= 1000) {
							displayVal = val - 1000
						}

						const dataPointIndex = opts.dataPointIndex
						const seriesLength = opts.w.config.series[opts.seriesIndex].data.length

						if (dataPointIndex === seriesLength - 1) {
							return displayVal
						} else {
							return displayVal.toFixed(2)
						}
					}
				},
				tooltip: {
					enabled: false
				},
				yaxis: {
					name: 'name',
					labels: {
						style: {
							direction: 'rlt',
							// colors: ['bl'],
							fontWeight: 1000,
							cssClass: ''
							// letterSpacing: '3px',
							// whiteSpace: 10
						}
					}
				},
				theme: {
					mode: this.$vuetify.theme.dark ? 'dark' : 'light'
				},
				stroke: {
					width: 1
				}
				// grid: {
				// 	padding: {
				// 		right: 10
				// 	}
				// }	
				// fill: {
				// 	type: 'pattern',
				// 	pattern: {
				// 		strokeWidth: 0.5
				// 	}
				// }
			}
		}
	},

	methods: {
		onEdit () {
			if (!this.selectedWorkday) return
			this.$router.push({
				name: 'add-papper-task',
				params: {
					id: this.selectedWorkday.workdayId
				}
			})
			this.showMenu = false
		},
		onDetails () {
			// Add navigation to details page if it exists
			console.log('Navigate to details for:', this.selectedWorkday)
			this.showMenu = false
		},
		// newRangArr () {
		// 	for (let i = 0; i < this.usersRang.length; i++) {
		// 		// console.log(this.usersRang)
		// 		this.usersRang[i].data.push({
		// 			date: ' ',
		// 			workdayId: '00000000-0000-0000-0000-000000000000',
		// 			workingHours: this.usersRang[i].remainingTime,
		// 			actualWorkingHours: this.usersRang[i].actualWorkingHours
		// 		},
		// 		{
		// 			date: ' ',
		// 			workdayId: '00000000-0000-0000-0000-000000000000',
		// 			workingHours: this.usersRang[i].remainingTime,
		// 			actualWorkingHours: this.usersRang[i].actualWorkingHours
		// 		}
		// 		)
		// 		console.log(this.usersRang[i].data.length)
		// 		for (let j = 0; j < this.usersRang[i].data.length; j++) {
		// 			this.usersRang[i].data[j].x = (this.usersRang[i].data[j].date !== ' ') ? this.moment(this.usersRang[i].data[j].date).format('LL').split(' ')[1].split(',')[0] : j === this.usersRang[i].data.length - 1 ? 'A W H' : 'R H'
		// 			this.usersRang[i].data[j].y = (j === this.usersRang[i].data.length - 1) ? this.usersRang[i].data[j].actualWorkingHours > 0 ? (this.usersRang[i].data[j].actualWorkingHours) : 0 : (this.usersRang[i].data[j].workingHours / 60).toFixed(2)
		// 		}	
		// 	}
		// },

		newRangArr () {
			for (let i = 0; i < this.usersRang.length; i++) {
				// console.log(this.this.usersRang)
				this.usersRang[i].data.push({
					date: ' ',
					workdayId: '00000000-0000-0000-0000-000000000000',
					workingHours: this.usersRang[i].remainingTime,
					actualWorkingHours: this.usersRang[i].actualWorkingHours
				},
				{
					date: ' ',
					workdayId: '00000000-0000-0000-0000-000000000000',
					workingHours: this.usersRang[i].remainingTime,
					actualWorkingHours: this.usersRang[i].actualWorkingHours
				}
				)
				console.log(this.usersRang[i].data.length)
				for (let j = 0; j < this.usersRang[i].data.length; j++) {
					this.usersRang[i].data[j].isLeave = true
					// check if leaves find
					if (this.usersRang[i].data[j].workHoursRequired === this.usersRang[i].data[j].workingHours) {
						this.usersRang[i].data[j].isLeave = false
					} else if (this.usersRang[i].data[j].workHoursRequired > this.usersRang[i].data[j].workingHours) {
						const diff = this.usersRang[i].data[j].workHoursRequired - this.usersRang[i].data[j].workingHours
						if (diff === this.usersRang[i].data[j].leaveDurationInMinute) {
							this.usersRang[i].data[j].isLeave = true
						} else {
							this.usersRang[i].data[j].isLeave = false
						}
					} else {
						this.usersRang[i].data[j].isLeave = false
					}
					this.usersRang[i].data[j].x = (this.usersRang[i].data[j].date !== ' ') ? this.moment(this.usersRang[i].data[j].date).format('LL').split(' ')[1].split(',')[0] : j === this.usersRang[i].data.length - 1 ? 'A W H' : 'R H'
					
					let yVal
					if (j === this.usersRang[i].data.length - 1) {
						yVal = this.usersRang[i].data[j].actualWorkingHours > 0 ? this.usersRang[i].data[j].actualWorkingHours : 0
					} else {
						yVal = this.usersRang[i].data[j].workingHours / 60
					}
					console.log(this.usersRang[i].data[j].isLeave)
					if (this.usersRang[i].data[j].isLeave) {
						this.usersRang[i].data[j].y = yVal + 1000
					} else {
						this.usersRang[i].data[j].y = yVal
					}
				}	
			}
		},
		
		nextMonth () {
			this.selectedMonth = moment(this.selectedMonth).add(1, 'month').format('YYYY-MM')
			this.getStatistics()
		},

		prevMonth () {
			this.selectedMonth = moment(this.selectedMonth).subtract(1, 'month').format('YYYY-MM')
			this.getStatistics()
		},
		moment,
		getStatistics (isFirst = false) {
			this.loading = true
			this.$store.dispatch('statsctics/fetchMonthlyReport', { 
				fromDate: moment(this.moment(this.selectedMonth).startOf('month')).format('YYYY-MM-DD'),
				toDate: moment(this.moment(this.selectedMonth).endOf('month')).format('YYYY-MM-DD')
			}).then((data) => {
				this.usersRang = data.data
				this.newRangArr()
			}).finally(() => {
				if (!isFirst) this.loading = false
			})
		}
	},

	created () {
		this.loading = true
		Promise.all([
			this.$store.dispatch('users/fetchUsersWithoutPag', { isActiveOnly: true }),
			// this.$store.dispatch('statsctics/fetchMonthlyReport', { 
			// 	fromDate: this.moment().startOf('month').format('YYYY-MM-DD'),
			// 	toDate: this.moment().endOf('month').format('YYYY-MM-DD')
			// }).then((data) => {
			// 	this.usersRang = data.data
			// 	this.newRangArr()
			// })
			this.getStatistics(true)
		]).finally(() => {
			this.loading = false
		})
	}
}
</script>
<style>
/* .apexcharts-text tspan {
	letter-spacing: 3px;
} */
.apexchart {
  letter-spacing: normal;  
}

div#colTable {
	flex: 0 0 4.3333333333% !important;
    max-width: 4.3333333333% !important;
}
div#colChart {
    flex: 0 0 95.66%;
    max-width: 95.6666666667%;
}

tspan {
	font-family: 'Zain', sans-serif !important
}

</style>
<style scoped lang='scss'>

// .red {
//     height: 35px; 
//     background-color: #e94747;
// }
// .done {
//     height: 35px; 
//     background-color: #3AB16E;
// }
// .orange {
//     height: 35px;
//     background-color: orange;
// }
// .grey {
//     height: 35px;
//     background-color: grey;
// }

td.text-start.pa-0.v-data-table__divider {
    display: flex;
    align-items: center;
    justify-items: center;
}

</style>
